import React, { FC } from 'react';
import { useI18nPath } from '../../../../config/clientRoutes/hooks';
import { IStudentBookBagLastViewdTrajectory } from 'src/config/api/models/Book';
import {
  StyledLink,
  StyledTrajectoryTitle,
  TrajectoriesListHeader,
  TrajectoriesListWrapper,
} from './Atoms';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';
import { FontAwesomeSpriteIcon } from 'src/modules/shared/components/FontAwesomeLocal';
import { useTheme } from '@material-ui/core';

type Props = {
  bookId: string;
  lastViewedTrajectory?: IStudentBookBagLastViewdTrajectory;
};

const UnfinishedTrajectoriesList: FC<Props> = ({ bookId, lastViewedTrajectory }) => {
  const { getPath } = useI18nPath();
  const theme = useTheme();

  return (
    <TrajectoriesListWrapper>
      <TrajectoriesListHeader>
        <FontAwesomeSpriteIcon
          icon={SpriteIconsLight.RECENT}
          color={theme.palette.secondary.main}
        />{' '}
        {'Laatst geopend'}
      </TrajectoriesListHeader>
      {lastViewedTrajectory ? (
        <StyledLink
          to={getPath('trajectoryView', {
            bookId,
            chapterId: lastViewedTrajectory.chapterId,
            trajectoryId: lastViewedTrajectory.trajectoryId,
          })}
        >
          <StyledTrajectoryTitle>{lastViewedTrajectory.trajectoryTitle}</StyledTrajectoryTitle>
        </StyledLink>
      ) : (
        'Nog niet geopend'
      )}
    </TrajectoriesListWrapper>
  );
};

export default UnfinishedTrajectoriesList;
